import React, {Component} from 'react';
import { Slider } from '@carbon/react';
import PropertyComponent from './PropertyComponent';
import * as midi from '../js/rpl_midi.js';

class ParameterSlider extends PropertyComponent {

	constructor(props) {
		super(props);

		this.min = props.min || 0;
		this.max = props.max || 100;
		this.ccBipolar = (props.ccBipolar && props.ccBipolar != 0) ? true : false;
		this.restoreChangeTimer = null;

		this.handleChange = this.handleChange.bind(this);
		this.formatLabel  = this.formatLabel.bind(this);
	}

	render() {
		var onChange = this.state.suppressChange ? undefined : this.handleChange;

		/*
		 * min: minimum value
		 * max: maximum value
		 * step: 
		 * stepMultiplier: note: it is misspelled as 'stepMuliplier' in the
		 * Carbon Slider component.
		 * formatLabel: used to format 
		 */
		return (
			<Slider value={this.state.value} min={this.min} max={this.max} step={0.1} stepMultiplier={40} stepMuliplier={40} labelText={this.labelText} formatLabel={this.formatLabel} onChange={onChange} disabled={this.state.disabled} hideTextInput="1"/>
		);
	}

	handleChange(props) {
		var newValue = Number(props.value)
		var paramValue = (newValue - this.min) / (this.max - this.min);
		this.setState({value: newValue});
		midi.setParameterValue(this.propId, paramValue);
	}

	formatLabel(value, label) {
		return '';
	}

	handleControlChange(ccNum, ccValue) {
		var paramValue = ccValue;
		if (this.ccBipolar) {
			paramValue = paramValue - 64;
			if (paramValue < 0) {
				paramValue = paramValue / 64;
			} else {
				paramValue = paramValue / 63;
			}
			paramValue = 0.5 + 0.5 * paramValue;
		} else {
			paramValue = paramValue / 127;
		}
		this.setValue(paramValue);
	}

	setValue(x) {
		var sliderValue = this.min + x * (this.max - this.min);
		sliderValue = Math.round(sliderValue * 10) / 10;
		if (this.restoreChangeTimer) {
			clearTimeout(this.restoreChangeTimer);
		}
		this.setState({value: sliderValue, suppressChange: true});
		this.restoreChangeTimer = setTimeout(() => {
			this.restoreChangeTimer = null;
			this.setState({suppressChange: false});
		}, 50);
	}
}

export default ParameterSlider;
